import { render, staticRenderFns } from "./authEnterpriseLegal.vue?vue&type=template&id=1dd63b9b&scoped=true"
import script from "./authEnterpriseLegal.vue?vue&type=script&lang=js"
export * from "./authEnterpriseLegal.vue?vue&type=script&lang=js"
import style0 from "./authEnterpriseLegal.vue?vue&type=style&index=0&id=1dd63b9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd63b9b",
  null
  
)

export default component.exports